import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PersonnelSection = ({ personnel }) => {
  const getRoleBadgeColor = (role) => {
    const colors = {
      'Supervisor': 'bg-primary/10 text-primary',
      'Safety Officer': 'bg-success/10 text-success',
      'Technician': 'bg-accent/10 text-accent',
      'Worker': 'bg-muted text-muted-foreground'
    };
    return colors?.[role] || 'bg-muted text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Users" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Assigned Personnel</h2>
      </div>
      <div className="space-y-3">
        {personnel?.map((person) => (
          <div key={person?.id} className="flex items-center gap-4 p-3 rounded-lg border border-border hover:bg-accent/5 transition-colors">
            <div className="relative">
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-border">
                <Image 
                  src={person?.avatar} 
                  alt={person?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              {person?.certified && (
                <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-success rounded-full border-2 border-card flex items-center justify-center">
                  <Icon name="CheckCircle2" size={12} color="white" />
                </div>
              )}
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-sm font-medium text-foreground truncate">{person?.name}</h3>
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getRoleBadgeColor(person?.role)}`}>
                  {person?.role}
                </span>
              </div>
              <div className="flex items-center gap-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Briefcase" size={12} />
                  {person?.employeeId}
                </span>
                <span className="flex items-center gap-1">
                  <Icon name="Phone" size={12} />
                  {person?.contact}
                </span>
              </div>
            </div>

            {person?.certified && (
              <div className="flex items-center gap-1 px-2 py-1 bg-success/10 rounded text-xs text-success font-medium">
                <Icon name="Award" size={12} />
                Certified
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonnelSection;